const styles = () => ({
  field: {
    width: '49%'
  }
})

export default styles
